import React from "react";
import "./SteakIcon.scss";
import gif from "./gif-icon.png"
import tick from "./tick-icon.png"

export default function SteakIcon({isDisabled=true, isGif=false}) {
  return (
    <div className={isDisabled ? "steak-icon-disabled" : "steak-icon"}>
        <img className="steak-img-icon" style={{"position": "relative", "top": -5, "left": -5}} src={isGif ? gif : tick} alt="reward-icon" />
    </div>
  )
}
